import React from 'react';
import { useTranslation } from 'react-i18next';
import { PLATFORM_PERMISSIONS, PLATFORM_RULES } from '@thinknet-gmbh/platform-common';

import { PageLayout } from '@thinknet-gmbh/platform-common-ui';
import { DocumentImporterList } from './document-importer-list';
import PermissionRouteGuard from '../../components/permission-route-guard';

const DocumentImporter: React.FC = () => {
  const { t } = useTranslation('documentImporter');
  return (
    <PermissionRouteGuard
      permission={PLATFORM_PERMISSIONS.documentImporter}
      rule={PLATFORM_RULES.manageAll}
    >
      <PageLayout pageTitle={t('labels.documentImporter')}>
        <DocumentImporterList />
      </PageLayout>
    </PermissionRouteGuard>
  );
};

export default DocumentImporter;
